import { makeStyles } from '@material-ui/core/styles';
export const useCardStyles = makeStyles((theme) => ({
    cardsColumn: {
        marginTop: 12,
        marginBottom: 12,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        [theme.breakpoints.down('md')]: { marginTop: 10, marginBottom: 10, gap: 10 },
        [theme.breakpoints.down('sm')]: { marginTop: 8, marginBottom: 8, gap: 8 },
    },
    cardRoot: {
        boxSizing: 'border-box',
        padding: 20,
        backgroundColor: 'var(--card-bg, #fff)',
        borderRadius: 4,
        border: '1px solid var(--card-border, #e5e7eb)',
        display: 'flex',
        flexDirection: 'row',
        gap: 12,
        minHeight: 96,                     // base min-height (no hard fixed heights)
        transition: 'min-height .2s ease, padding .2s ease',
        [theme.breakpoints.down('md')]: { padding: 16, gap: 10, minHeight: 86 },
        [theme.breakpoints.down('sm')]: { padding: 12, gap: 8, minHeight: 74, borderRadius: 3 },
    },
    cardRootHasData: {
        minHeight: 128,                    // slightly taller when content exists
        [theme.breakpoints.down('md')]: { minHeight: 112 },
        [theme.breakpoints.down('sm')]: { minHeight: 92 },
    },
    cardIconWrap: {
        height: 36,
        width: 24,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        [theme.breakpoints.down('sm')]: { height: 28, width: 18 },
    },
    cardBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        flex: 1,
        minHeight: 0,
    },
    cardTitle: {
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '21px',
        [theme.breakpoints.down('md')]: { fontSize: 13, lineHeight: '20px' },
        [theme.breakpoints.down('sm')]: { fontSize: 12, lineHeight: '18px' },
        flexShrink: 0,
    },
    cardText: {
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '21px',
        color: '#2B2C35',
        flex: 1,
        overflow: 'auto',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
        paddingRight: 4,
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
        [theme.breakpoints.down('md')]: { fontSize: 13, lineHeight: '20px' },
        [theme.breakpoints.down('sm')]: { fontSize: 12, lineHeight: '18px', paddingRight: 2 },
    },
    cardTextHasData: {
        maxHeight: 84,
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
        [theme.breakpoints.down('md')]: { maxHeight: 64 },
        [theme.breakpoints.down('sm')]: { maxHeight: 56 },
    },
    cardTextEmpty: {
        maxHeight: 20,
        paddingRight: 0,
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
        [theme.breakpoints.down('sm')]: { maxHeight: 18 },
    },
}));

export const useCommonStyles = makeStyles((theme) => ({
    statusDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        border: '1px solid #ddd',
        alignItems: 'center',
        borderRadius: 4,
        padding: 5,
        marginTop: 10,
        fontSize: 13,
    },
    statusDivAction: {
        display: 'flex',
        alignItems: 'center',
    },
    rootContainer: {
        marginTop: "20px"
    },
    titleBlock: {
        display: "flex",
        alignItems: "center"
    },
    title: {
        fontWeight: "bold",
        fontSize: "14px"
    },
    addIcon: {
        marginLeft: "8px",
        cursor: "pointer"
    },
    tableHeaderCell: {},
    tableActions: {
        display: "flex",
        alignItems: "center"
    },
    actionIcon: {
        cursor: "pointer"
    },
    inputField: {
        width: "100%",
        height: "35px",
        paddingLeft: "5px"
    },
    selectField: {
        height: "35px",
    },

    columnContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        [theme.breakpoints.down('md')]: { gap: 8 },
        [theme.breakpoints.down('sm')]: { gap: 6 },
    },
    sectionTitleText: {
        fontWeight: 400,
        fontSize: 14,
        color: 'rgba(43, 44, 53, 1)',
        fontStyle: 'normal',
        lineHeight: '21px',
        [theme.breakpoints.down('md')]: { fontSize: 13.5, lineHeight: '20px' },
        [theme.breakpoints.down('sm')]: { fontSize: 13, lineHeight: '19px' },
    },
    sectionTitleTextClamp: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 0,
        maxWidth: 300,
        [theme.breakpoints.down('lg')]: { maxWidth: 260 },
        [theme.breakpoints.down('md')]: { maxWidth: 220 },
        [theme.breakpoints.down('sm')]: { maxWidth: 180 },
        [theme.breakpoints.down('xs')]: { maxWidth: 150 },
    },

    fieldLabelClamp: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 0,
        maxWidth: 300,
        [theme.breakpoints.down('lg')]: { maxWidth: 100 },
        [theme.breakpoints.down('md')]: { maxWidth: 80 },
        [theme.breakpoints.down('sm')]: { maxWidth: 30 },
        [theme.breakpoints.down('xs')]: { maxWidth: 25 },
    },
    gridItemMargins: {
        marginTop: 2,
        marginBottom: 2,
    },
    fullWidthBox: {
        width: '100%',
    },
    labelRow: {
        display: 'flex',
        alignItems: 'center',
    },
    fieldLabel: {
        fontWeight: 400,
        fontSize: 12,
        color: 'rgba(120, 121, 142, 1)',
        fontStyle: 'medium',
        [theme.breakpoints.down('md')]: { fontSize: 11.5 },
        [theme.breakpoints.down('sm')]: { fontSize: 11 },
    },
    fieldWrapper: {
        marginTop: 4,
        width: '100%',
    },
}));

export const useInputStyles = makeStyles((theme) => ({
    smallOutlinedInput: {
        fontSize: '12px',
        height: '32px',
        color: '#454653',
        '& input': { fontSize: '12px', padding: '0px' },
        "&.Mui-disabled": { color: "#5F6071" },
        [theme.breakpoints.down('md')]: {
            height: '30px',
            padding: '5px 8px',
            '& input': { padding: '5px 6px' },
        },
        [theme.breakpoints.down('sm')]: {
            height: '28px',
            padding: '4px 8px',
            '& input': { padding: '4px 6px' },
        },
    },
    smallNotchedOutline: {
        fontSize: '12px',
        borderColor: '#ccc',
        [theme.breakpoints.down('sm')]: { fontSize: '11.5px' },
    },
}));
